import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export default new Router({
    routes: [{
        path: '/',
        redirect: '/RunningStatus'
    },
    // routes: [{
    //     path: '/',
    //     redirect: '/BigScreen'
    // },
    {
        path: '/',
        component: () =>
            import( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
        meta: {
            title: '自述文件'
        },
        children: [{
            path: '/BasicInfo',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/BasicInfo.vue'),
            meta: {
                title: 'KJ927煤炭产量管理系统首页'
            }
        },
        {
            path: '/BeltScalePage',
            component: () =>
                import('../components/common/BeltScalePage.vue'),
            meta: {
                title: '皮带秤首页'
            }
        },
        {
            path: '/BigScreen',
            name: 'BigScreen',
            // 使用HTML页面
            beforeEnter() {
                window.location.href = '/bigscreen/BigScreen.html';
            }
        },
        {
            path: '/ScaleRackGroup',
            component: () =>
                import('../components/AIWeighingSystem/ScaleRackGroup.vue'),
            meta: {
                title: '秤架组管理'
            }
        },
        {
            path: '/ScaleRackRoller',
            component: () =>
                import('../components/AIWeighingSystem/ScaleRackRoller.vue'),
            meta: {
                title: '托辊管理'
            }
        },
        {
            path: '/RollersElectricMotor',
            component: () =>
                import('../components/AIWeighingSystem/RollersElectricMotor.vue'),
            meta: {
                title: '托辊电机管理'
            }
        },
        {
            path: '/RollersLoadCells',
            component: () =>
                import('../components/AIWeighingSystem/RollersLoadCells.vue'),
            meta: {
                title: '托辊称重传感器管理'
            }
        },
        {
            path: '/RollersShockSensor',
            component: () =>
                import('../components/AIWeighingSystem/RollersShockSensor.vue'),
            meta: {
                title: '托辊震动传感器管理'
            }
        },
        {
            path: '/AiWeighingSystemSetup',
            component: () =>
                import('../components/AIWeighingSystem/AiWeighingSystemSetup.vue'),
            meta: {
                title: 'AI称重系统设置'
            }
        },
        {
            path: '/AiMonitorEqu',
            component: () =>
                import('../components/AIWeighingSystem/AiMonitorEqu.vue'),
            meta: {
                title: 'AI称重系统监控设置'
            }
        },
        {
            path: '/BasicInfoHome',
            component: () =>
                import('../components/common/BasicInfoHome.vue'),
            meta: {
                title: '皮带秤首页'
            }
        },
        {
            path: '/DynamicInformation',
            component: () =>
                import('../components/common/DynamicInformation.vue'),
            meta: {
                title: '动态信息'
            }
        },
        {
            path: '/BeltScaleCondition',
            component: () =>
                import('../components/common/BeltScaleCondition.vue'),
            meta: {
                title: '皮带秤状态'
            }
        },
        {
            path: '/RunningStatus',
            component: () =>
                import('../components/common/RunningStatus.vue'),
            meta: {
                title: '运行状态'
            }
        },
        {
            path: '/HandoverList',
            component: () =>
                import('../components/Scale/HandoverList.vue'),
            meta: {
                title: '交接清单'
            }
        },
        {
            path: '/MoreDeviceInfo',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/MoreDeviceInfo.vue'),
            meta: {
                title: '设备运行信息'
            }
        },
        {
            path: '/DeviceList',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/DeviceList.vue'),
            meta: {
                title: '设备列表'
            }
        },
        {
            path: '/WashingProductAuditForm',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/WashingProductAuditForm.vue'),
            meta: {
                title: '洗选产品审核表'
            }
        },
        {
            path: '/WashingProductDailyReport',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/WashingProductDailyReport.vue'),
            meta: {
                title: '洗选产品日报表'
            }
        },
        {
            path: '/CoalWashDataSet',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/CoalWashDataSet.vue'),
            meta: {
                title: '洗选数据平台功能设置'
            }
        },
        {
            path: '/ScaleIndex',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/ScaleIndex.vue'),
            meta: {
                title: '给料机首页'
            }
        },
        {
            path: '/MonitorInfo',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/MonitorInfo.vue'),
            meta: {
                title: '监测信息'
            }
        },
        {
            path: '/About',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/About.vue'),
            meta: {
                title: '系统信息'
            }
        },
        {
            path: '/GlobalSet',
            component: () =>
                import( /* webpackChunkName: "dashboard" */ '../components/common/GlobalSet.vue'),
            meta: {
                title: '全局设置'
            }
        },
        {
            path: '/UserManage',
            component: () =>
                import('../components/SysManage/UserManage'),
            meta: {
                title: '用户管理'
            }
        },
        {
            path: '/PersonInfo',
            component: () =>
                import('../components/SysManage/PersonInfo'),
            meta: {
                title: '个人信息'
            }
        },
        {
            path: '/Balance',
            component: () =>
                import('../components/Scale/Balance'),
            meta: {
                title: '设备管理'
            }
        },
        {
            path: '/MotorMonitoringDevice',
            component: () =>
                import('../components/Scale/MotorMonitoringDevice'),
            meta: {
                title: '电机监测设备'
            }
        },
        {
            path: '/ProductPlan',
            component: () =>
                import('../components/Scale/ProductPlan'),
            meta: {
                title: '产量计划'
            }
        },
        {
            path: '/Dept',
            component: () =>
                import('../components/SysManage/Dept'),
            meta: {
                title: '部门管理'
            }
        },
        {
            path: '/CoalPreparationPlant',
            component: () =>
                import('../components/SysManage/CoalPreparationPlant'),
            meta: {
                title: '选煤厂管理'
            }
        },
        {
            path: '/Frequency',
            component: () =>
                import('../components/Scale/Frequency'),
            meta: {
                title: '计划管理'
            }
        },
        {
            path: '/ScaleGroup',
            component: () =>
                import('../components/Scale/ScaleGroup.vue'),
            meta: {
                title: '给料机组管理'
            }
        },
        {
            path: '/BalanceEmpower',
            component: () =>
                import('../components/Scale/BalanceEmpower.vue'),
            meta: {
                title: '设备权限'
            }
        },
        {            
            path: '/DischargeCurve',            redirect: '/CombinedCurve'        
        },        
        {            
            path: '/CombinedCurve',            
            component: () =>                
                import('../components/Scale/CombinedCurve.vue'),            
            meta: {                title: '流量速度曲线'            }        
        },
        {            
            path: '/SpeedCurve',            
            redirect: '/CombinedCurve'        },
        {
            path: '/RecordSearch',
            component: () =>
                import('../components/Scale/RecordSearch.vue'),
            meta: {
                title: '记录查询'
            }
        },
        {
            path: '/CoalInforUploadRecord',
            component: () =>
                import('../components/Scale/CoalInforUploadRecord.vue'),
            meta: {
                title: '煤炭信息监管服务平台上传记录'
            }
        },
        {
            path: '/CoalWashDataUploadRecord',
            component: () =>
                import('../components/Scale/CoalWashDataUploadRecord.vue'),
            meta: {
                title: '洗选数据联网数据上传记录'
            }
        },
        {
            path: '/ClearData',
            component: () =>
                import('../components/Scale/ClearData.vue'),
            meta: {
                title: '数据清空'
            }
        },
        {
            path: '/HisData',
            component: () =>
                import('../components/Scale/HisData.vue'),
            meta: {
                title: '历史数据'
            }
        },
        {
            path: '/StartStopRecord',
            component: () =>
                import('../components/Scale/StartStopRecord.vue'),
            meta: {
                title: '启停记录'
            }
        },
        {
            path: '/MotorInfo',
            component: () =>
                import('../components/Scale/MotorInfo.vue'),
            meta: {
                title: '电机信息'
            }
        },
        {
            path: '/OfflineRecord',
            component: () =>
                import('../components/Scale/OfflineRecord.vue'),
            meta: {
                title: '离线记录'
            }
        },
        {
            path: '/YearCCData',
            component: () =>
                import('../components/Scale/YearCCData.vue'),
            meta: {
                title: '年超产查询'
            }
        },
        {
            path: '/MonthCCData',
            component: () =>
                import('../components/Scale/MonthCCData.vue'),
            meta: {
                title: '月超产查询'
            }
        },
        {
            path: '/FrequencyData',
            component: () =>
                import('../components/Scale/FrequencyData.vue'),
            meta: {
                title: '班产量查询'
            }
        },
        {
            path: '/HourData',
            component: () =>
                import('../components/Scale/HourData.vue'),
            meta: {
                title: '时产量查询'
            }
        },
        {
            path: '/DayData',
            component: () =>
                import('../components/Scale/DayData.vue'),
            meta: {
                title: '日产量查询'
            }
        },
        {
            path: '/MonthData',
            component: () =>
                import('../components/Scale/MonthData.vue'),
            meta: {
                title: '月产量查询'
            }
        },
        {
            path: '/YearData',
            component: () =>
                import('../components/Scale/YearData.vue'),
            meta: {
                title: '年产量查询'
            }
        },
        {
            path: '/HourlyPower',
            component: () =>
                import('../components/Scale/HourlyPower.vue'),
            meta: {
                title: '时用电量查询'
            }
        },
        {
            path: '/DailyPower',
            component: () =>
                import('../components/Scale/DailyPower.vue'),
            meta: {
                title: '日用电量查询'
            }
        },
        {
            path: '/MonthlyPower',
            component: () =>
                import('../components/Scale/MonthlyPower.vue'),
            meta: {
                title: '月用电量查询'
            }
        },
        {
            path: '/AnnualPower',
            component: () =>
                import('../components/Scale/AnnualPower.vue'),
            meta: {
                title: '年用电量查询'
            }
        },
        {
            path: '/DailySales',
            component: () =>
                import('../components/Scale/DailySales.vue'),
            meta: {
                title: '日累计销量'
            }
        },
        {
            path: '/MonthlySales',
            component: () =>
                import('../components/Scale/MonthlySales.vue'),
            meta: {
                title: '月累计销量'
            }
        },
        {
            path: '/AnnualSales',
            component: () =>
                import('../components/Scale/AnnualSales.vue'),
            meta: {
                title: '年累计销量'
            }
        },
        {
            path: '/SalesDetails',
            component: () =>
                import('../components/Scale/SalesDetails.vue'),
            meta: {
                title: '磅单详情'
            }
        },
        {
            path: '/DataMain',
            component: () =>
                import('../components/SysManage/DataMain.vue'),
            meta: {
                title: '数据字典'
            }
        },
        {
            path: '/Menu',
            component: () =>
                import('../components/SysManage/Menu.vue'),
            meta: {
                title: '菜单管理'
            }
        },
        {
            path: '/Role',
            component: () =>
                import('../components/SysManage/Role.vue'),
            meta: {
                title: '角色管理'
            }
        },
        {
            path: '/EquimentVersion',
            component: () =>
                import('../components/SysManage/EquimentVersion.vue'),
            meta: {
                title: '协议版本信息'
            }
        },
        {
            path: '/componentsA',
            component: () =>
                import('../components/TestUnit/componentsA.vue'),
            meta: {
                title: '组件A'
            }
        },
        {
            path: '/componentsC',
            component: () =>
                import('../components/TestUnit/componentsC.vue'),
            meta: {
                title: '组件C'
            }
        },
        {
            path: '/componentsD',
            component: () =>
                import('../components/TestUnit/componentsD.vue'),
            meta: {
                title: '组件D'
            }
        },
        {
            path: '/BaseForm',
            component: () =>
                import('../components/page/BaseForm.vue'),
            meta: {
                title: '基础表单'
            }
        },
        {
            path: '/EventRecord',
            component: () =>
                import('../components/Scale/EventRecord.vue'),
            meta: {
                title: '监控记录'
            }
        },
        {
            path: '/Tabs',
            component: () =>
                import('../components/page/Tabs.vue'),
            meta: {
                title: '消息中心'
            }
        },
        {
            path: '/MonitorEqu',
            component: () =>
                import('../components/SysManage/MonitorEqu.vue'),
            meta: {
                title: '监控设备'
            }
        },
        {
            path: '/RolePermission',
            component: () =>
                import('../components/SysManage/role-permission.vue'),
            meta: {
                title: '角色权限'
            }
        },
        {
            path: '/componentsB',
            component: () =>
                import('../components/TestUnit/componentsB.vue'),
            meta: {
                title: '组件B'
            }
        },
        {
            path: '/404',
            component: () =>
                import( /* webpackChunkName: "404" */ '../components/page/404.vue'),
            meta: {
                title: '404'
            }
        },
        {
            path: '/donate',
            component: () =>
                import( /* webpackChunkName: "donate" */ '../components/page/Donate.vue'),
            meta: {
                title: '支持作者'
            }
        },
        ]
    },
    {
        path: '/login',
        component: () =>
            import( /* webpackChunkName: "login" */ '../components/page/Login.vue')
    },
    {
        path: '*',
        redirect: '/404'
    },
    {
        path: '/3d',
        name: '3d',
        component: () => import('../views/3d/Meta3d.vue'),
    },
    ]
});